import { render, staticRenderFns } from "./AppNavigation.vue?vue&type=template&id=37080022&scoped=true&"
import script from "./AppNavigation.vue?vue&type=script&lang=js&"
export * from "./AppNavigation.vue?vue&type=script&lang=js&"
import style0 from "./AppNavigation.vue?vue&type=style&index=0&id=37080022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37080022",
  null
  
)

component.options.__file = "AppNavigation.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VNavigationDrawer } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarSideIcon } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VAvatar,
  VBtn,
  VDivider,
  VFlex,
  VLayout,
  VList,
  VListTile,
  VListTileContent,
  VNavigationDrawer,
  VSpacer,
  VToolbar,
  VToolbarSideIcon,
  VToolbarTitle,
})
